import React from 'react';
import { Controller } from 'react-hook-form';

import { MezzaFormField, MezzaFormFieldProps } from '../MezzaForm';
import { inputLabels } from '../../../data/labels';
import Input from '../../Input/Input';

const Building = ({ control }: MezzaFormFieldProps) => {
  return (
    <Controller
      control={control}
      name={MezzaFormField.BUILDING}
      render={({ field }) => (
        <Input
          id={MezzaFormField.BUILDING}
          value={field.value}
          setValue={field.onChange}
          label={inputLabels.building}
        />
      )}
    />
  );
};

export default React.memo(Building);
